import React, { useContext, useEffect, useState } from 'react';
import { DashboardContainerColorProps } from 'enums/DashboardContainerEnums';
import styles from './Transportation.module.scss';
import CreateProductContainer from 'views/CreateProductContainer';
import { TransportationConstants } from './TransportationConstants';
import { Formik, FieldArray } from 'formik';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import ProductsService from 'services/ProductsService/products.service';
import SupplierService from 'services/ValueChainService/supplier.service';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { convertToOptions } from '../RawMaterial/RawMaterialHelper';
import { TransportationProps } from 'enums/TransportationEnums';
import { ProductTransportation } from 'models/ProductTransportation/productTransportation.model';
import { validationSchema } from './TransportationConstants';
import FlowContainer from 'views/FlowContainer';
import CreateSupplierModal from 'shared/components/CreateSupplierModal';
import {
  CategoryOptions,
  transformedDataTransportation,
} from '../CreateProductFlowInterfaces';
import { TransformTransportationForm } from './TransportationHelpers';
import COAlertModal from 'shared/components/COAlertModal';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import isProductDisabled from 'shared/utils/isProductDisabled';
import TransportationIngredientList from './TransportationIngredientList';
import TransportationPackagingList from './TransportationPackagingList';
import { handleSaveAsDraftForTransportation } from './handleSaveAsDraftForTransportation';
import Stage1AndStage2ProductService from 'services/ProductsService/stage1AndStage2Product.service';
import ProductCreationService from 'services/ProductsService/productCreation.service';

const CreateProductTransportaion: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const productId = Number(id);

  if (!productId) {
    navigate(AppRoutes.DASHBOARD);
  }

  const [formData, setFormData] = useState<transformedDataTransportation>();
  const [supplierOptionsList, setSupplierOptionsList] = useState<
    CategoryOptions[]
  >([]);

  const { USER_DETAILS, CLOSE_LABEL, CONFIRM_LABEL, HEADING } =
    TransportationConstants;
  const [createSupplierModalState, setCreateSupplierModalState] =
    useState<boolean>(false);
  const { loading, fetchSuppliers, supplierList, createSupplier } =
    SupplierService();
  const { fetchData, fetchedHelpDeskData } = HelpdeskService();
  const {
    updateTransportation,
    saveAsDraftUpdateTransportation,
    buttonLoading,
    draftButtonLoading,
  } = ProductsService();
  const { fetchSingleProduct: fetchChildProductData, newProduct } =
    ProductCreationService();
  const {
    fetchRawMaterialListing,
    rawMaterialList,
    transportationList,
    fetchTranportationListing,
  } = Stage1AndStage2ProductService();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  useEffect(() => {
    fetchSuppliers({ size: 250 });
  }, []);

  useEffect(() => {
    fetchedHelpDeskData && setHelpDeskData(fetchedHelpDeskData);
  }, [fetchedHelpDeskData]);

  useEffect(() => {
    fetchRawMaterialListing(productId);
    fetchTranportationListing(productId);
    fetchChildProductData(productId);
  }, [productId]);

  useEffect(() => {
    let data;
    data = TransformTransportationForm(transportationList);

    setFormData(data);
    const supplierOptions = convertToOptions(supplierList);
    setSupplierOptionsList(supplierOptions);
  }, [
    rawMaterialList,
    supplierList,
    productId,
    transportationList,
    newProduct?.stage,
  ]);

  const handleOpenCreateSupplierModal = () => {
    setCreateSupplierModalState(true);
  };

  const [cancelModalState, setCancelModalState] = useState<boolean>(false);
  const handleCloseCreateSupplierModal = () => {
    setCreateSupplierModalState(false);
  };
  const isDisabled = isProductDisabled(newProduct?.status);

  const initialValues = {
    ingredients: formData
      ? formData.ingredients
      : [
          {
            ingredientName: undefined,
            ingredientOrigin: undefined,
            supplier: undefined,
            temperatureControl: undefined,
            viaAir: false,
          },
        ],
    packageMaterials: formData ? formData.packageMaterials : [],
  };
  const handleGoBack = () => {
    navigate(
      generatePath(
        `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL}`,
        { id: id }
      )
    );
  };

  const transformPayload = (payload: transformedDataTransportation) => {
    const transformedPayload: ProductTransportation[] = [];
    payload.ingredients.forEach(ingredient => {
      ingredient.multipleOrigin?.forEach(origin => {
        transformedPayload.push({
          id: origin.id,
          type: TransportationProps.INGREDIENT,
          productRawMaterialId: origin.productRawMaterialId,
          supplierId:
            typeof origin.supplier === 'object'
              ? origin.supplier.value
              : origin.supplier,
          temperatureControl: origin.temperatureControl,
          transportationAir: origin.transportationAir || false,
          origin: origin.origin,
        });
      });
    });
    payload.packageMaterials?.forEach(packageMaterial => {
      packageMaterial.multipleOrigin?.forEach(origin => {
        transformedPayload.push({
          id: origin.id,
          type: TransportationProps.PACKAGING,
          productRawMaterialId: origin.productRawMaterialId,
          supplierId:
            typeof origin.supplier === 'object'
              ? origin.supplier.value
              : origin.supplier,
          temperatureControl: TransportationProps.AMBIENT,
          transportationAir: origin.transportationAir || false,
          origin: origin.origin,
        });
      });
    });
    return transformedPayload;
  };
  const handleFormSubmission = async (
    values: transformedDataTransportation
  ) => {
    if (isDisabled === true) {
      navigate(
        generatePath(
          `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_PROCESSING_FACILITY}`,
          { id: productId }
        )
      );
    } else {
      const payload = transformPayload(values);
      await updateTransportation(productId, payload as ProductTransportation);
    }
  };

  const handleSaveAsDraft = async (payload: transformedDataTransportation) => {
    const transformedPayload = transformPayload(payload);
    await saveAsDraftUpdateTransportation(
      productId,
      transformedPayload as ProductTransportation,
      {
        save_draft: true,
      }
    );
  };
  const user = localStorage.getItem(USER_DETAILS);
  let parsedUser: any;
  if (user !== null) {
    parsedUser = JSON.parse(user);
  }
  const handleOpenCancelModal = () => setCancelModalState(true);

  const handleConfirmCancelModal = () => {
    navigate(`${AppRoutes.PRODUCT}/${AppRoutes.DRAFT}`);
  };
  const handleCloseModal = () => {
    setCancelModalState(false);
  };

  const [supplierDetails, setsupplierDetails] = useState<string>();
  const setSupplierDetails = (fieldName: string) => {
    setsupplierDetails(fieldName);
  };
  return (
    <>
      <FlowContainer bgColor={DashboardContainerColorProps.GREY}>
        {({}) => (
          <>
            <CreateProductContainer>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmission}>
                {formikProps => (
                  <form onSubmit={formikProps.handleSubmit}>
                    <CreateSupplierModal
                      showModalState={createSupplierModalState}
                      handleModalCancel={handleCloseCreateSupplierModal}
                      handleModalConfirm={handleCloseCreateSupplierModal}
                      createSupplier={createSupplier}
                      id={parsedUser.id}
                      successCallback={async supplierId => {
                        await fetchSuppliers({ size: 250 });
                        !!supplierId &&
                          formikProps.setFieldValue(
                            `${supplierDetails}`,
                            Number(supplierId)
                          );
                      }}
                      loading={loading}
                    />
                    <COAlertModal
                      handleModalCancel={() =>
                        handleSaveAsDraftForTransportation(
                          formikProps,
                          handleSaveAsDraft
                        )
                      }
                      handleModalConfirm={handleConfirmCancelModal}
                      onModalCancel={handleCloseModal}
                      showModalState={cancelModalState}
                      alertModal
                      confirmLabel={CLOSE_LABEL}
                      cancelLabel={CONFIRM_LABEL}
                      heading={HEADING}
                    />
                    <FieldArray name={TransportationProps.INGREDIENTS}>
                      {() => (
                        <TransportationIngredientList
                          handleGoBack={handleGoBack}
                          buttonLoading={buttonLoading}
                          isDisabled={isDisabled}
                          handleOpenCancelModal={handleOpenCancelModal}
                          draftButtonLoading={draftButtonLoading}
                          handleSaveAsDraft={handleSaveAsDraft}
                          handleOpenCreateSupplierModal={
                            handleOpenCreateSupplierModal
                          }
                          supplierOptionsList={supplierOptionsList}
                          setSupplierDetails={setSupplierDetails}
                          fetchData={fetchData}
                          formData={formData}
                        />
                      )}
                    </FieldArray>
                    {formData && formData?.packageMaterials.length > 0 && (
                      <div className={styles.packagingMaterialFormContainer}>
                        <FieldArray name={TransportationProps.PACKAGE_MATERIAL}>
                          {() => (
                            <TransportationPackagingList
                              isDisabled={isDisabled}
                              handleOpenCreateSupplierModal={
                                handleOpenCreateSupplierModal
                              }
                              supplierOptionsList={supplierOptionsList}
                              setSupplierDetails={setSupplierDetails}
                              fetchData={fetchData}
                              formData={formData}
                            />
                          )}
                        </FieldArray>
                      </div>
                    )}
                  </form>
                )}
              </Formik>
            </CreateProductContainer>
          </>
        )}
      </FlowContainer>
    </>
  );
};

export default CreateProductTransportaion;
